import { ELLIPSIS, ELLIPSIS_IN_BEGIN, ELLIPSIS_IN_END, ELLIPSIS_IN_MIDDLE } from '@shared/ui/pagination';

export const getPageNumbers = (totalPage: number, currentPage: number) => {
  if (totalPage <= 7) {
    return new Array(totalPage).fill(null).map((_, index) => index + 1);
  }

  const ellipsisLocation = getEllipsisLocation(currentPage, totalPage);

  if (ellipsisLocation === ELLIPSIS_IN_BEGIN) {
    return [1, ELLIPSIS, totalPage - 4, totalPage - 3, totalPage - 2, totalPage - 1, totalPage];
  }

  if (ellipsisLocation === ELLIPSIS_IN_END) {
    return [1, 2, 3, 4, 5, ELLIPSIS, totalPage];
  }

  return [1, ELLIPSIS, currentPage - 1, currentPage, currentPage + 1, ELLIPSIS, totalPage];
};

const getEllipsisLocation = (currentPage: number, totalPage: number) => {
  if (currentPage < 5) {
    return ELLIPSIS_IN_END;
  }

  if (currentPage > totalPage - 4) {
    return ELLIPSIS_IN_BEGIN;
  }

  return ELLIPSIS_IN_MIDDLE;
};
